import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import AuthService from "../session/AuthService.js";
import "react-widgets/styles.css";

class AuthRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUserType: AuthService.getUserTypeAdmin(),
    };
  }
  render() {
    const { userAccess } = this.props;
    console.log("userAccess:::::", userAccess, this.state.authUserType);
    console.log(
      "authUserType:::::",
      userAccess.includes(this.state.authUserType)
    );
    // (userAccess).includes(this.state.authUserType)
    if (AuthService.isAuth() && userAccess.includes(this.state.authUserType)) {
      return <Route {...this.props} />;
    } else if (!AuthService.isAuth()) {
      //   AuthService.removeAuth();
      //   return <Redirect to="/" />;
      return null;
    } else {
      //   return <Redirect to="/login" />;
      return null;
    }
  }
}

export default AuthRoute;
